__turbopack_context__.v({
  "header": "style-module-scss-module__CPzjSG__header",
  "link": "style-module-scss-module__CPzjSG__link",
  "linkArrow": "style-module-scss-module__CPzjSG__linkArrow",
  "section": "style-module-scss-module__CPzjSG__section",
  "showMoreButton": "style-module-scss-module__CPzjSG__showMoreButton",
  "title": "style-module-scss-module__CPzjSG__title",
});
